<template>
  <div>
    <div v-if="!errorPage">
      <Card class="location-dashboard-card mt-6">
        <div class="location-dashboard_inner">
          <div class="location-stats-row">
            <div class="location-stat-lead">
              <Icon
                icon-name="users"
                size="s"
                class="location-stat-lead_icon !text-flame"
              />
              <div class="location-stat-lead_copy">
                <p class="location-stat_label">Total employee count</p>
                <p class="location-stat_value">{{ totalEmployeesDisplay }}</p>
              </div>
            </div>
            <div class="location-stat-group">
              <div class="location-stat-block">
                <Icon
                  icon-name="icon-map"
                  size="s"
                  class-name="location-stat-block_icon "
                />
                <div class="location-stat-block_copy">
                  <p class="location-stat_label">Number of locations</p>
                  <p class="location-stat_value">{{ locationCountDisplay }}</p>
                </div>
              </div>
              <div class="location-stat-block">
                <Icon
                  icon-name="users"
                  size="s"
                  class-name="location-stat-block_icon text-flame"
                />
                <div class="location-stat-block_copy">
                  <p class="location-stat_label">Total remote employees</p>
                  <p class="location-stat_value">{{ remoteEmployeesDisplay }}</p>
                </div>
              </div>
              <div class="location-stat-block">
                <Icon
                  icon-name="users"
                  size="s"
                  class-name="location-stat-block_icon text-flame"
                />
                <div class="location-stat-block_copy">
                  <p class="location-stat_label">Total onsite employees</p>
                  <p class="location-stat_value">{{ onsiteEmployeesDisplay }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="location-dashboard_rule" aria-hidden="true" />

          <div class="location-actions-row">
            <Button
              class="text-white location-btn-primary"
              :background="appearance.buttonColor || defaultBTNColor"
              @click="requestAddLocation"
            >
              New Location
            </Button>
          </div>

          <div class="location-dashboard_rule" aria-hidden="true" />

          <div class="">
            <card-footer
              reloadcard
              showcalendar
              :calendar-preset-options="locationDateRangePresets"
              :selected-calendar-preset="selectedDateRange"
              @calendarPresetSelect="handleDateRangeSelect"
              :show-map-pin="false"
              @sortType="handleSort($event)"
              @searchResult="handleSearch($event)"
              @reload="handleReload"
            />
          </div>

        <div v-if="loading && !hasLoadedOnce" class="location-body-loading">
          <loader size="xxs" :loader-image="false" />
        </div>

        <div
          v-else-if="!locationData.length"
          class="location-empty"
        >
          <Icon
            icon-name="location-empty"
            size=""
            class-name="location-empty_illustration"
          />
          <p class="location-empty_text">
            A list of profiled locations for your organisaton will shown here. Start by adding one using the button below.
          </p>
          <div
            class="cursor-pointer text-flame flex flex-row  items-center gap-2"
            @click="requestAddLocation"
          >
          <icon icon-name="icon-plus" size="xs"   class="text-flame "/>
            <span>Add New Location</span>
          </div>
        </div>

        <div v-else class="location-table-wrap">
          <sTable
            :headers="locationHeader"
            :items="locationData"
            aria-label="show location"
            :loading="loading"
            :pagination-list="metaData"
            has-number
            @page="handlePage($event)"
            @filter="handleFilter($event)"
            @itemsPerPage="handleItemsPerPage($event)"
            page-sync
            class="w-full mb-4"
          >
            <template v-slot:item="{ item }">
              <span v-if="item.name" class="">{{ item.data.name }}</span>
              <span v-if="item.address" class="">{{ item.data.address }}</span>
              <span v-if="item.country" class="">{{ item.data.country }}</span>
              <span v-if="item.state" class="">{{ item.data.state }}</span>
              <span v-if="item.employeesCount" class="">{{
                item.data.employeesCount
              }}</span>
              <span v-if="item.numberOfRemoteEmployees" class="">{{
                remoteCountForRow(item.data)
              }}</span>
              <span v-if="item.numberOfOnsiteEmployees" class="">{{
                onsiteCountForRow(item.data)
              }}</span>
              <span class="flex" v-if="item.id">
                <Menu left top="-15" class="p-0" margin="30">
                  <template v-slot:title>
                    <icon
                      icon-name="more_icon"
                      size="xsm"
                      class="-mt-1"
                      style="padding: 3px 10px; width: 36px; height: 36px"
                    />
                  </template>
                  <div style="width: 158px" class="py-3 px-2">
                    <div
                      class="flex py-1 px-3 h-8 cursor-pointer"
                      @click="editLocation(item.data)"
                    >
                      <icon
                        icon-name="edit"
                        class-name="text-blueCrayola mr-2"
                        size="xs"
                      />
                      <p class="pt-1" style="font-size: 14px">View and Edit</p>
                    </div>
                    <div
                      v-if="!item.data.isDefaultOffice"
                      class="flex px-3 py-1 more h-8 cursor-pointer"
                      @click="confirmDeleteLocation(item.data)"
                    >
                      <icon
                        icon-name="delete"
                        class-name="text-desire mr-2"
                        size="xs"
                      />
                      <p class="pt-1" style="font-size: 14px">Delete</p>
                    </div>
                  </div>
                </Menu>
              </span>
              <span v-else-if="item.stateId">
                {{ handleState(item.data.stateId) }}
              </span>
            </template>
          </sTable>
        </div>
        </div>
      </Card>

      <add-location
        :open-modal="id ? openEditModal : openModal"
        @close="handleClose"
        :id="id"
      />
      <Modal v-if="deleteDialog">
        <Card class="p-5 flex flex-col max-w-md">
          <div class>
            <p class="font-bold ml-4 my-5 text-center">
              Are you sure you want to delete this Location?
            </p>
            <div class="flex">
              <Button
                class="text-white"
                :background="appearance.buttonColor || defaultBTNColor"
                @click="deleteLocation"
              >
                Yes
              </Button>
              <Button
                background-color="none"
                class="text-dynamicBackBtn border border-solid border-dynamicBackBtn ml-4"
                @click="deleteDialog = false"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Card>
      </Modal>
    </div>

    <div v-else>
      <ErrorPage />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import STable from "@scelloo/cloudenly-ui/src/components/table";
import Card from "@/components/Card";
import CardFooter from "@/components/CardFooter";
import Menu from "@/components/Menu";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Icon from "@/components/Icon";
import states from "@/helpers/states";
import ErrorPage from "@/modules/Admin/error403";

const LOCATION_DATE_RANGE_PRESETS = Object.freeze([
  "Last 7 days",
  "Last 30 days",
  "Last 60 days",
  "Last week",
  "Last month",
  "Last 6 months",
  "Last year",
]);

export default {
  name: "Location",
  components: {
    Card,
    STable,
    Menu,
    CardFooter,
    ErrorPage,
    Modal,
    Button,
    Icon,
    AddLocation: () => import("./sideActions/addLocation"),
  },
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      states,
      id: "",
      deleteDialog: false,
      metaData: {},
      locationId: "",
      openEditModal: false,
      itemsPerPage: null,
      numberOfPage: null,
      searchWord: null,
      errorPage: false,
      loading: true,
      hasLoadedOnce: false,
      sortType: null,
      locationData: [],
      hrSummary: {
        numberOfOnsiteEmployees: 0,
        numberOfRemoteEmployees: 0,
        numberOfTotalEmployees: null,
        numberOfLocations: null,
      },
      locationDateRangePresets: LOCATION_DATE_RANGE_PRESETS,
      selectedDateRange: LOCATION_DATE_RANGE_PRESETS[0],
      locationHeader: [
        { title: "LOCATION NAME", value: "name", width: 16 },
        { title: "ADDRESS", value: "address", width: 22 },
        { title: "COUNTRY", value: "country", width: 12 },
        { title: "STATE", value: "state", width: 10 },
        { title: "EMPLOYEES", value: "employeesCount", width: 10 },
        {
          title: "REMOTE E...",
          value: "numberOfRemoteEmployees",
          width: 12,
        },
        {
          title: "ONSITE E...",
          value: "numberOfOnsiteEmployees",
          width: 12,
        },
        { title: "", value: "id", image: true },
      ],
    };
  },

  computed: {
    ...mapState({
      defaultBTNColor: (state) => state.orgAppearance.defaultBtnColor,
      appearance: (state) => state.orgAppearance.orgAppearanceData,
    }),
    locationCountDisplay() {
      const fromSummary = this.hrSummary.numberOfLocations;
      if (fromSummary != null && fromSummary !== "") {
        return fromSummary;
      }
      const total = this.metaData && this.metaData.total;
      if (total != null) {
        return total;
      }
      return this.locationData.length;
    },
    totalEmployeesDisplay() {
      const n = this.hrSummary.numberOfTotalEmployees;
      if (n != null && n !== "") {
        return n;
      }
      return (
        Number(this.hrSummary.numberOfOnsiteEmployees || 0) +
        Number(this.hrSummary.numberOfRemoteEmployees || 0)
      );
    },
    remoteEmployeesDisplay() {
      return this.hrSummary.numberOfRemoteEmployees ?? 0;
    },
    onsiteEmployeesDisplay() {
      return this.hrSummary.numberOfOnsiteEmployees ?? 0;
    },
  },

  methods: {
    remoteCountForRow(row) {
      const v =
        row.numberOfRemoteEmployees ??
        row.remoteEmployeesCount ??
        row.remoteEmployeeCount;
      if (v != null && v !== "") {
        return v;
      }
      return "—";
    },
    onsiteCountForRow(row) {
      const v =
        row.numberOfOnsiteEmployees ??
        row.onsiteEmployeesCount ??
        row.onsiteEmployeeCount;
      if (v != null && v !== "") {
        return v;
      }
      return "—";
    },
    requestAddLocation() {
      this.$emit("add-location");
    },
    handleReload() {
      this.queryUpdate();
    },
    handleDateRangeSelect(range) {
      this.selectedDateRange = range;
    },
    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },
    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },
    handleState(stateNo) {
      const result = this.states.find((state) => state.id === stateNo);
      if (result) {
        return result.name;
      }
      return stateNo;
    },
    getName(value, array) {
      if (!value) {
        return "";
      }
      const result = array.find(({ id }) => id === value);
      if (result) {
        return result.name;
      }
      return value;
    },
    buildQueryString() {
      const search = this.searchWord ? `&search=${this.searchWord}` : "";
      const sort = this.sortType ? `&sort=${this.sortType}` : "";
      let page = 1;
      if (this.numberOfPage != null) {
        page = this.numberOfPage;
      } else if (this.metaData && this.metaData.page != null) {
        page = this.metaData.page;
      }
      const pageNumber = `&page=${page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      return `${sort}${pageNumber}${itemPage}${search}`;
    },
    queryUpdate() {
      this.fetchLocationsAndSummary(this.buildQueryString());
    },
    async fetchLocationsAndSummary(query) {
      this.loading = true;
      try {
        const [locRes, sumRes] = await Promise.all([
          this.$_getHumanarLocations(query),
          this.$_getOutletsHrSummary().catch(() => ({ data: {} })),
        ]);
        this.locationData = locRes.data.outlets || [];
        this.metaData = locRes.data.meta || {};
        const s = sumRes.data || {};
        this.hrSummary = {
          numberOfOnsiteEmployees: s.numberOfOnsiteEmployees ?? 0,
          numberOfRemoteEmployees: s.numberOfRemoteEmployees ?? 0,
          numberOfTotalEmployees:
            s.numberOfTotalEmployees ??
            s.totalEmployees ??
            null,
          numberOfLocations:
            s.numberOfLocations ?? s.totalLocations ?? s.outletCount ?? null,
        };
      } catch (e) {
        this.$toasted.error(
          (e && e.message) || "Failed to load locations",
          { duration: 5000 }
        );
      } finally {
        this.loading = false;
        this.hasLoadedOnce = true;
      }
    },
    async editLocation(data) {
      this.id = "";
      try {
        await this.$handlePrivilege("location", "editLocation");
        this.id = data.id;
        this.openEditModal = true;
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },
    handleClose() {
      this.id = "";
      this.queryUpdate();
      this.openEditModal = false;
      this.$emit("close");
    },
    handleSort(sortType) {
      const changeSortType = sortType.split(":");
      let result;
      if (changeSortType[0] === "createdAt") {
        result = sortType;
      } else {
        result = `name:${changeSortType[1]}`;
      }
      this.sortType = result;
      this.queryUpdate();
    },
    handleSearch(searchWord) {
      if (searchWord) {
        this.searchWord = searchWord;
      } else {
        this.searchWord = null;
      }
      this.queryUpdate();
    },
    handleFilter() {},
    async confirmDeleteLocation(data) {
      try {
        await this.$handlePrivilege("location", "deleteLocation");
        this.locationId = data.id;
        this.deleteDialog = true;
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },
    async deleteLocation() {
      this.deleteDialog = false;
      this.loading = true;
      this.$_deleteOutlet([this.locationId])
        .then(() => {
          this.queryUpdate();
        })
        .catch((err) => {
          this.$toasted.error(err, { duration: 5000 });
          this.queryUpdate();
        });
    },
  },
  async mounted() {
    try {
      await this.$handlePrivilege("location", "viewRegister");
      this.fetchLocationsAndSummary(this.buildQueryString());
    } catch (error) {
      this.errorPage = true;
    }
  },
};
</script>

<style scoped>
/* Dashboard shell — Figma node 185:405 */
.location-dashboard-card {
  border-radius: 16px;
  box-shadow:
    0 1px 2px rgba(45, 49, 66, 0.06),
    0 1px 3px rgba(8, 7, 8, 0.1);
}

.location-dashboard_inner {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
}

.location-dashboard_rule {
  width: 100%;
  height: 0;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin: 0;
}

/* Summary row */
.location-stats-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.location-stat-lead {
  flex: 0 0 237px;
  box-sizing: border-box;
  max-width: 100%;
  min-height: 65px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 24px;
  background: #fcf4ff;
  border-radius: 16px;
}

.location-stat-lead_icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: #985EAF;
  fill: #985EAF;
  stroke: #985EAF;
}

.location-stat-lead_copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}

.location-stat-group {
  flex: 1 1 220px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 8px;
  min-width: 0;
}

.location-stat-block {
  flex: 1 1 0;
  min-width: 140px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 16px 12px;
  background: #fff;
  border-radius: 12px;
  box-shadow: -153px 231px 77px 0 rgba(0, 0, 0, 0.00), -98px 148px 71px 0 rgba(0, 0, 0, 0.01), -24px 37px 44px 0 rgba(0, 0, 0, 0.05);

}

.location-stat-block_icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.location-stat-block_copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}

.location-stat_label {
  margin: 0;
  font-size: 10px;
  font-weight: 900;
  line-height: 1.4;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  color: #878e99;
}

.location-stat_value {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.24px;
  color: #333;
}

@media (max-width: 900px) {
  .location-stat-lead {
    flex: 1 1 100%;
  }

  .location-stat-group {
    flex: 1 1 100%;
  }
}

/* Primary action row */
.location-actions-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 18px;
  width: 100%;
}

.location-btn-primary {
  min-height: 44px;
  padding: 12px 15px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.21px;
}

/* Toolbar — align with Figma table controls */
.location-toolbar-footer-wrap {
  width: 100%;
  min-width: 0;
}

.location-toolbar-footer-wrap :deep(.flex.w-full) {
  align-items: center;
}

.location-toolbar-footer-wrap :deep(.flex.ml-auto .cardClass) {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;
}

.location-toolbar-footer-wrap :deep(.mt-6) {
  margin-top: 0 !important;
}

.location-toolbar-footer-wrap :deep(.-mt-2) {
  margin-top: 0 !important;
}

.location-toolbar-footer-wrap :deep(.search) {
  width: 320px !important;
  max-width: 100%;
}

.location-toolbar-footer-wrap :deep(.flex.ml-3.-mt-2) {
  background: #f7f7ff;
  border-radius: 8px;
  height: 40px;
  padding: 0 15px;
  box-sizing: border-box;
  align-items: center;
}

.location-toolbar-footer-wrap :deep(.dropDownMenuWrapper.w-10) {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
}

.location-body-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
}

.location-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 16px 40px;
}

.location-empty_illustration {
  width: 200px;
  height: 160px;
  max-width: 100%;
}

.location-empty_title {
  margin: 20px 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #321c3b;
}

.location-empty_text {
  margin: 0 0 24px;
  max-width: 400px;
  font-size: 15px;
  line-height: 1.5;
  color: #878e99;
}

.location-empty_cta {
  border-radius: 8px;
  min-height: 44px;
  padding: 12px 15px;
  font-size: 14px;
  font-weight: 600;
}

.location-table-wrap {
  padding-top: 4px;
}

.location-table-wrap :deep(tbody tr:nth-child(even)) {
  background: #f7f7ff;
}
</style>
